import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/VehicleSearchData'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class VehicleSearchDataStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "VehicleSearchDataStore",
			variables: false,
		})
	}
}

export async function load_VehicleSearchData(params) {
  await initClient()

	const store = new VehicleSearchDataStore()

	await store.fetch(params)

	return {
		VehicleSearchData: store,
	}
}
